import { FormEvent, useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { useClientContext } from 'client/context';
import { UserPassword } from 'client/voladeum/auth/types';
import { setToken } from 'ducks/user/slices';
import { Button } from 'framework/button';
import { Icon } from 'framework/Icon';
import { Input } from 'framework/Input';
import { PUBLIC } from 'router/routes';
import { useAppDispatch } from 'store/hooks';

import { user_password_default } from './defaults';

import cn from './PasswordResetPage.module.scss';
const { PUBLIC_URL } = process.env;

export default () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { code = '' } = useParams();

  const [form, setForm] = useState<UserPassword>({ ...user_password_default });
  const { Voladeum, handleError } = useClientContext();

  const onChange = useCallback(
    (user: Partial<UserPassword>) => setForm((prev) => ({ ...prev, ...user })),
    []
  );

  const onSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        const payload: UserPassword = { password: form.password };
        const res = await Voladeum.auth.resetPassword(code, payload);
        dispatch(setToken({ token: res.data }));
      } catch (err) {
        handleError(err);
      }
    },
    [form.password, Voladeum.auth, code, dispatch, handleError]
  );

  return (
    <div className={cn.page}>
      <div className={cn.container}>
        <form className={cn.form} onSubmit={onSubmit}>
          <div className={cn.logo}>
            <img src={`${PUBLIC_URL}/voladeum/voladeum-vertical.png`} alt="Voladeum" />
          </div>
          <Input
            height="34px"
            onChange={({ value }) => onChange({ password: value })}
            value={form.password}
            type="password"
            placeholder="Password"
          />
          <Button type="submit" width="100%" height="36px" shadow>
            Reset password
          </Button>
          <div className={cn.row}>
            <div className={cn.break} />
            <p className={cn.text}>OR</p>
            <div className={cn.break} />
          </div>
          <Button
            width="100%"
            height="36px"
            variant="secondary"
            onClick={() => navigate(PUBLIC.CREATE_ACCOUNT.path)}
            shadow
          >
            Create account
          </Button>
        </form>
        <a className={cn.back} onClick={() => navigate(PUBLIC.LOGIN.path)}>
          <Icon icon={faArrowLeft} size="14px" width="30px" />
          Sign in
        </a>
      </div>
    </div>
  );
};
